import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip } from "@mui/material";
import { fetchHelp } from "src/data/helpClass";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";

export default function HelperButton(props) {
  const helpId = props.helpId;

  const [otsikko, setOtsikko] = useState("");
  const [teksti, setTeksti] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const variant = props.variant || "outlined";
  const height = props.height || "60px";

  useEffect(() => {
    const asynk = async () => {
      // get help text from server
      const help = await fetchHelp(helpId);
      if (help) {
        setOtsikko(help.title);
        setTeksti(help.htmlText);
      }
      setIsLoading(false);
    };
    asynk();
  }, [helpId]);
  return (
    <Tooltip title={teksti} placement="top" arrow disableInteractive>
      <Button
        fullWidth
        onClick={props.onClick}
        aria-label="Näytä sisäinen muistiinpano"
        variant={variant}
        sx={{
          minHeight: { height },
          height: { height },
          minWidth: "40%",
          lineHeight: "1.2em",
        }}
      >
        {isLoading ? <ProgressCirc /> : otsikko ? otsikko : ""}
      </Button>
    </Tooltip>
  );
}

HelperButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  helpId: PropTypes.string.isRequired,
  variant: PropTypes.string,
  height: PropTypes.string,
};
